<div
  class="h-0.5 w-full"
  [class.bg-grey-350]="!isActive"
  [class.bg-main-pattern]="isActive"
></div>
